import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { NetworkHelperService } from '../../_services/network-helper.service';
import swal from 'sweetalert2';
import { API } from '../../_config/strings';
import { Router } from '@angular/router';

@Component({
  selector: 'app-listar-cotizaciones',
  templateUrl: './listar-cotizaciones.component.html',
  styleUrls: ['./listar-cotizaciones.component.scss']
})
export class ListarCotizacionesComponent implements OnInit {

  API: any;

  // variables para el datatable
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  // variables para strings

  // variables para arrays
  cotizacionesArray = [];
  cotizacionesArrayReverse = [];

  constructor(
    private network: NetworkHelperService,
    private router: Router) {
  }

  ngOnInit() {

    this.dtOptions = {
    language: {
        url: '//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json'
    },
    rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        $('td', row).unbind('click');
        $('td', row).bind('click', () => {
          this.selectedRowCotizacion(data);
        });
        return row;
    }
  };

  this.getCotizaciones();
  this.inverse();
  }

  selectedRowCotizacion(data) {
    console.log(data);
    this.router.navigate(['dashboard', 'verCotizaciones', data[0]]);
  }
  getCotizaciones() {
    this.network.callSecureService(
      // url
      'cotizaciones',
      // Metodo
      'GET',
      // content Type
      null)
      .subscribe((response: any) => {
        console.log(response);
        if (response.Estatus === 201) {
            const responseMensajecotizaciones = response.Mensaje.reverse();
            // this.cotizacionesArray = [];
            for (const cotizaciones of responseMensajecotizaciones) {
            this.cotizacionesArray.push({
              id: cotizaciones.cotizacionId,
              costoFlete: cotizaciones.costoFlete,
              desmontaje: cotizaciones.desmontaje,
              montaje: cotizaciones.montaje,
              noFletes: cotizaciones.noFletes,
              estatus: cotizaciones.estatus,
              // fecha: cotizaciones.fecha,
              fecha: cotizaciones.fecha.split('T')[0],
              descripcion: cotizaciones.descripcion,
              usuario: cotizaciones.usuario,
              sucursal: cotizaciones.sucursalNombre
            });
          }
          this.dtTrigger.next();
        } else {
        swal('Atencion', response.Mensaje, 'warning');
        }
      }, err => {
        console.log(err);
        swal('Error', 'error del servidor, intentalo de nuevo o llama sistemas', 'error');
      }
    );
  }

  inverse() {
    this.cotizacionesArrayReverse = this.cotizacionesArray.reverse();
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/listar-cotizaciones/listar-cotizaciones.component.ts